<template>
  <div class="home-page-wrapper content0-wrapper" id="aboutUs">
    <div class="bg"></div>
    <div class="content0">

      <div class="content0 home-page">
        <div>关于我们</div>
      </div>
      <div class="content1 home-page">
        <span class="p1">
          湖北泰跃卫星技术发展股份有限公司成立于1999年，是领先的信息系统解决方案服务商、数字乡村综合服务商。
          <span class="p2">
            公司致力于为用户提供智慧城市、数字乡村、智慧教育、智慧交通、智慧应急等行业领域的一站式解决方案，公司凭借着卓越的技术能力和“以客户为中心”的服务理念，获评国家级“专精特新”小巨人企业、高新技术企业。
            泰跃卫星秉持着“严谨、务实、专业、创新”的企业文化，大力投入产品研发，拥有以数位博士领衔的专业研发团队，在新基建和新型智慧城市的背景下持续创新，不断打磨产品性能，力争为用户提供更优质、更健全的服务和解决方案，全面赋能打造完整的智慧城市生态。
          </span>
        </span>
      </div>
      <div class="content2 home-page">
        <div class="item item1">
          <div class="title1">愿景及使命</div>
          <img src="@/assets/logo_dc.png" alt="" />
        </div>
        <div class="d"></div>
        <div class="item item2">
          <div class="title2">以客户为中心</div>
          <div class="title3" id="ContactUs">
            致力于为用户提供智慧城市、数字乡村、智慧教育、智慧交通、
            智慧应急等行业领域的一站式解决方案。
          </div>
        </div>
      </div>
      <div class="content3 home-page">
        <div class="p1">
          <img src="@/assets/about_1.png" alt="" />
        </div>
      </div>
      <div class="content4 home-page">
        <div class="p">
          <div class="img img1"></div>
          <div class="title">027-87772899（周一至周五 8:30-17:30）</div>
        </div>
        <div class="p">
          <div class="img img2"></div>
          <div class="title">topeak@hubeitopeak.com </div>
        </div>
        <div class="p">
          <div class="img img3"></div>
          <div class="title">
            武汉市洪山区野芷湖西路16号武汉创意天地3号楼七楼
          </div>
        </div>
      </div>
      <div class="content7">
        <div class="p1">办公地点</div>
        <div class="list">
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">公司总部</div>
              <div class="s2">
                武汉市洪山区野芷湖西路16号武汉创意天地3号楼7楼
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">宜昌分公司</div>
              <div class="s2">宜昌市西陵区环城北路9号老电信机房</div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">枝江分公司</div>
              <div class="s2">
                宜昌市枝江市仙女新经济产业园仙女路仙女大道210号
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">鄂州分公司</div>
              <div class="s2">
                鄂州市鄂城区滨湖东路61号(泰富广场)七楼
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">十堰分公司</div>
              <div class="s2">
                十堰市茅箭区重庆路99号汉成天地2号写字楼6层
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">咸宁分公司</div>
              <div class="s2">咸宁市咸安区长安大道218号</div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">荆门分公司</div>
              <div class="s2">
                荆门市掇刀区虎牙关大道9号星球世界城2号写字楼15楼
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">襄阳分公司</div>
              <div class="s2">襄阳市襄城新街16号(老公安局内)</div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">南通分公司</div>
              <div class="s2">
                南通市开发区崇州大道60号中央创新区紫琅科技城3号楼6层619
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">云南分公司</div>
              <div class="s2">云南省昆明市五华区金鼎科技园18号平台A座二楼</div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">陕西分公司</div>
              <div class="s2">
                陕西省西安市高新区丈八一路绿地蓝海大厦1102
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left"></div>
            <div class="item-right">
              <div class="s1">新疆分公司</div>
              <div class="s2">新疆克拉玛依市克拉玛依区吉云路197号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content0',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'content0'
    }
  }
}
</script>

<style scoped>
.content0-wrapper {
  width: 100%;
  overflow: hidden;
}

.content0-content {

}

.bg {
  width: 100%;
  height: 440px;
  background: url(@/assets/about_me.png) no-repeat center center / 100% 100%;
}

.content0 {
  max-width: 1200px;
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #333;
  position: relative;
  margin: 0 auto;
  padding: 30px 20px 60px;
  z-index: 1;

}
.content1{
  text-align: left;
}
.content1 .p1 {
  font-size: 24px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #242934;
  line-height: 48px;

}

.content1 .p2 {
  font-size: 16px;
  font-weight: 400;
  line-height: 48px;
}

.content2 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 50px;
  flex-wrap: wrap;
}

.content2 .item {
  text-align: center;
  padding: 20px;
}

.content2 .item1 .title1 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.content2 .item1 img {
  max-width: 200px;
  height: auto;
}

.content2 .d {
  width: 2px;
  height: 100px;
  background-color: #ddd;
  margin: 0 20px;
}

.content2 .item2 .title2 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.content2 .item2 .title3 {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  max-width: 400px;
}

.content3 .p1 {
  text-align: center;
  margin-bottom: 50px;
}

.content3 .p1 img {
  max-width: 100%;
  height: auto;
  max-height: 400px;
}

.content4 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 50px;
  flex-wrap: wrap;
}

.content4 .p {
  display: flex;
  align-items: center;
  margin: 10px;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.content4 .p .img {
  width: 40px;
  height: 40px;
  margin-right: 15px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.content4 .p .img1 {
  background-image: url('@/assets/about_2_1.png');
}

.content4 .p .img2 {
  background-image: url('@/assets/about_2_2.png');
}

.content4 .p .img3 {
  background-image: url('@/assets/about_2_3.png');
}

.content4 .p .title {
  font-size: 14px;
  color: #333;
}

.content7 .p1 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.content7 .list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.content7 .item {
  display: flex;
  gap: 15px;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
}

.content7 .item-left {
  margin-top: 6px;
  width: 25px;
  height: 18px;
  background: url(@/assets/about_4.png) no-repeat center center / 100% 100%;
}
.content7 .item-right {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

}
.content7 .item-right .s1 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.content7 .item-right .s2 {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.copyright-wrapper {
  margin-top: 60px;
  padding: 20px;
  background-color: #333;
}

.copyright {
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.copyright a {
  color: #fff;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content0 {
    font-size: 28px;
  }
  
  .content1 .p1 {
    font-size: 14px;
  }
  
  .content2 {
    flex-direction: column;
  }
  
  .content2 .d {
    width: 100px;
    height: 2px;
    margin: 20px 0;
  }
  
  .content4 {
    flex-direction: column;
  }
  
  .content4 .p {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
  .content7 .list {
    grid-template-columns: 1fr;
  }
}
</style>